module.exports = __webpack_public_path__ + "media/src/website/images/gift-cards/ci_2020/preview-cover-72f1ff44106dbb78b742df7dff2cdfb7.png";